// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../imageLarge.fragment.generated';
export const GalleryWithEnquiryCardFragmentDoc = gql`
    fragment galleryWithEnquiryCard on GalleryWithEnquiryCard {
  __typename
  image {
    ...imageLarge
  }
  caption
  slug
}
    ${ImageLargeFragmentDoc}`;
export const ComponentGalleryWithEnquiryFragmentDoc = gql`
    fragment componentGalleryWithEnquiry on ComponentGalleryWithEnquiry {
  __typename
  type
  items {
    ...galleryWithEnquiryCard
  }
}
    ${GalleryWithEnquiryCardFragmentDoc}`;